module.exports = __webpack_public_path__ + "static/Feature-02-bf31c45ec178c2331bbf0c2824e9b47d.png";